/* Pawgies theme JS — vanilla, no dependencies */
(function () {
  var money = function (cents) {
    return '€' + (cents / 100).toFixed(2);
  };

  /* Cart drawer */
  var overlay = document.getElementById('CartOverlay');
  var itemsEl = document.getElementById('CartDrawerItems');
  var subtotalEl = document.getElementById('CartDrawerSubtotal');
  var countEls = document.querySelectorAll('[data-cart-count]');

  function openCart() { document.body.classList.add('cart-open'); }
  function closeCart() { document.body.classList.remove('cart-open'); }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); renderCart(); openCart(); }
    if (e.target.closest('[data-cart-close]') || e.target === overlay) { closeCart(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  function renderCart() {
    if (!itemsEl) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      countEls.forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      if (subtotalEl) subtotalEl.textContent = money(cart.items_subtotal_price);
      if (cart.item_count === 0) {
        itemsEl.innerHTML = '<div class="cart-empty"><p>Your cart is empty.</p><a class="btn btn--orange" href="/collections/all">Shop the collection</a></div>';
        return;
      }
      itemsEl.innerHTML = cart.items.map(function (item) {
        return (
          '<div class="cart-line" data-key="' + item.key + '">' +
            '<img src="' + (item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2') : '') + '" alt="" loading="lazy">' +
            '<div>' +
              '<p class="cart-line__title">' + item.product_title + '</p>' +
              '<p class="cart-line__meta">' + (item.variant_title || '') + '</p>' +
              '<div class="qty">' +
                '<button type="button" data-qty-minus aria-label="Decrease quantity">−</button>' +
                '<input type="text" value="' + item.quantity + '" data-qty-input inputmode="numeric" aria-label="Quantity">' +
                '<button type="button" data-qty-plus aria-label="Increase quantity">+</button>' +
              '</div>' +
            '</div>' +
            '<div style="text-align:right">' +
              '<p class="cart-line__price">' + money(item.final_line_price) + '</p>' +
              '<button type="button" class="cart-line__remove" data-remove>Remove</button>' +
            '</div>' +
          '</div>'
        );
      }).join('');
    });
  }

  function changeLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function () { renderCart(); });
  }

  document.addEventListener('click', function (e) {
    var line = e.target.closest('.cart-line');
    if (!line) return;
    var key = line.getAttribute('data-key');
    var input = line.querySelector('[data-qty-input]');
    var qty = parseInt(input.value, 10) || 1;
    if (e.target.closest('[data-qty-plus]')) changeLine(key, qty + 1);
    if (e.target.closest('[data-qty-minus]')) changeLine(key, Math.max(0, qty - 1));
    if (e.target.closest('[data-remove]')) changeLine(key, 0);
  });

  /* Product form */
  var productForm = document.querySelector('form[data-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = productForm.querySelector('[type="submit"]');
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', body: new FormData(productForm) })
        .then(function (r) { return r.json(); })
        .then(function () { renderCart(); openCart(); })
        .finally(function () { btn.disabled = false; });
    });

    var qtyInput = productForm.querySelector('[data-qty-input]');
    productForm.addEventListener('click', function (e) {
      if (e.target.closest('[data-qty-plus]')) qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      if (e.target.closest('[data-qty-minus]')) qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
    });
  }

  /* Gallery thumbs */
  var mainImg = document.querySelector('[data-gallery-main] img');
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (mainImg) mainImg.src = thumb.getAttribute('data-src');
    });
  });

  /* Variant price */
  var variantScript = document.getElementById('ProductVariants');
  if (variantScript && productForm) {
    var variants = JSON.parse(variantScript.textContent);
    var idInput = productForm.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    productForm.addEventListener('change', function () {
      var selected = [];
      productForm.querySelectorAll('.opt-pills').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) selected.push(checked.value);
      });
      var match = variants.find(function (v) {
        return selected.every(function (val, i) { return v.options[i] === val; });
      });
      if (match) {
        idInput.value = match.id;
        if (priceEl) priceEl.innerHTML = money(match.price) + (match.compare_at_price > match.price ? ' <s>' + money(match.compare_at_price) + '</s>' : '');
      }
    });
  }

  /* Collection filter panel (mobile) */
  var filterToggle = document.querySelector('[data-filter-toggle]');
  var filterPanel = document.querySelector('[data-filter-panel]');
  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', function () {
      var open = filterPanel.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Mobile nav */
  var menuToggle = document.querySelector('.menu-toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Email popup — re-offers after N days instead of never returning */
  var popup = document.getElementById('EmailPopup');
  if (popup) {
    var delay = parseInt(popup.getAttribute('data-delay'), 10);
    if (isNaN(delay)) delay = 6;
    var days = parseInt(popup.getAttribute('data-days'), 10) || 30;
    var seen = parseInt(localStorage.getItem('pawgies_popup_seen'), 10) || 0;
    if (!seen || (Date.now() - seen) > days * 86400000) {
      setTimeout(function () { popup.classList.add('is-open'); }, delay * 1000);
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]') || e.target === popup) {
        popup.classList.remove('is-open');
        localStorage.setItem('pawgies_popup_seen', Date.now());
      }
    });
  }

  /* Initial cart count */
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  });
})();
